import Tooltip from 'rc-tooltip';

import { InputText, Svg } from '~shared/ui';

import { DeviceWithKey } from './edit-store';

type DeviceProps = {
	device: DeviceWithKey;
	onChangeNumber: (key: string, value: string) => void;
	onChangeCode: (key: string, value: string) => void;
	onDelete?: (key: string) => void;
	errorNumber?: string | null;
	errorCode?: string | null;
};

export function DeviceItem({ device, onDelete, onChangeNumber, onChangeCode, errorNumber, errorCode }: DeviceProps) {
	const handleDelete = () => {
		if (onDelete) {
			if (!device.number || confirm('Вы уверены?')) onDelete(device.key);
		}
	};

	const handleChangeNumber = (val: string) => {
		onChangeNumber(device.key, val);
	};

	const handleChangeCode = (val: string) => {
		onChangeCode(device.key, val);
	};

	return (
		<>
			<div className="col col--33">
				<InputText
					placeholder="Номер устройства"
					value={device.number ?? ''}
					onChange={handleChangeNumber}
					error={errorNumber}
				/>
			</div>
			<div className="col col--33">
				<InputText
					placeholder="Идентификатор устройства"
					value={device.code ?? ''}
					onChange={handleChangeCode}
					error={errorCode}
				/>
			</div>
			{onDelete && (
				<div className="col">
					<Tooltip placement="top" overlay="Удалить устройство">
						<button className="btn red" onClick={handleDelete}>
							<Svg name="cross" />
						</button>
					</Tooltip>
				</div>
			)}
		</>
	);
}
